export function isPrivateEmailStringUtil (email) {
  return /privaterelay/gi.test(email)
}
